<template>
  <div class="button-bar">
    <slot></slot>
  </div>
</template>
<style lang="scss" scoped>
.button-bar {
  & > * {
    margin-left: 5px;

    &:first-child {
      margin-left: 0;
    }
  }
}
</style>
